import Vue from 'vue'

import d2Container from './d2-container'
import moneyEditor from './common/money-editor.vue';
import moneyView from './common/money-view.vue';

Vue.component('money-editor', moneyEditor);
Vue.component('money-view', moneyView);
// 注意 有些组件使用异步加载会有影响
Vue.component('d2-container', d2Container)
Vue.component('d2-icon', () => import('./d2-icon/index.vue'))
Vue.component('d2-icon-svg', () => import('./d2-icon-svg/index.vue'))
